import { createModule } from '../../createModule';
export const createPremialabAPI = createModule(({ http }) => {
    return {
        getDailyComposition: async (params) => {
            const res = await http.get('/v2/premialab/daily-composition/template', { params });
            return res;
        },
        postDailyComposition: async (body) => {
            const res = await http.post('/v2/premialab/daily-composition/template', { body: body });
            return res;
        },
        uploadDailyComposition: async (body) => {
            const res = await http.post('/v2/premialab/daily-composition/upload', { body: body });
            return res;
        },
    };
});
